import alt from 'alt'
import { createStore } from 'alt-utils/lib/decorators'
import { SERPPreviewActions } from 'actions'

@createStore(alt)
export default class SERPPreviewStore {
  constructor() {
    this.state = {
      fetchingPreviews: null,
      previews: null
    }

    this.bindActions(SERPPreviewActions)
  }

  static displayName = 'SERPPreviewStore'

  setFetchingPreviews(fetching) {
    this.setState({ fetchingPreviews: fetching })
  }

  setFetchedPreviews(resp) {
    this.setState(resp)
    this.setState({ fetchingPreviews: false })
  }
}



// WEBPACK FOOTER //
// ./app/stores/SERPPreviewStore.js